module.exports = __webpack_public_path__ + "img/Middle-Semi-Elliptical-Attachment-L-24.2408ade8.png";